import { Pipe, PipeTransform } from '@angular/core';
import { LssEntityStatus } from '../store/deployment.datamodel';

/**
 * Pipe to get the style to use in the display of a deployment status.
 */
@Pipe({
    name: 'statusStyle',
    standalone: false
})
export class StatusStylePipe implements PipeTransform {
    transformer = {
        [LssEntityStatus.TO_BE_DEPLOYED]: 'bg-info',
        [LssEntityStatus.TO_BE_UNDEPLOYED]: 'bg-dark',
        [LssEntityStatus.TO_BE_EXCLUDED]: 'bg-info',
        [LssEntityStatus.TO_BE_UNEXCLUDED]: 'bg-dark',
        [LssEntityStatus.DEPLOYED]: '',
        [LssEntityStatus.EXCLUDED]: '',
        [LssEntityStatus.UNDEPLOYED]: '',
        [LssEntityStatus.TO_REMOVE_OVERRIDE]: '',
        [LssEntityStatus.OVERRIDE]: '',
    };
    transform(status: LssEntityStatus): string {
        return this.transformer[status] ?? '';
    }
}
